import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SphereIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        fill="none"
      />
      <ellipse
        cx="12"
        cy="12"
        rx="10"
        ry="4"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        fill="none"
      />
      <path
        d="M12 2a10 10 0 0 1 0 20"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        fill="none"
      />
    </BaseIcon>
  ),
);

SphereIcon.displayName = 'SphereIcon';
